import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAlignLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAlignLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bfa82b0da0314f49bee3e688ff1304cfa37454f6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '454ab9dfd67aa9cdb4397d5814fca75da6382c9f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6ec6598032e0f386ef14bf6438d18daaac905c13', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 5.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 6zm0 5.25a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zm.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-align-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-align-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-align-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAlignLeft$1);
            }
            break;
    } });
}

const CosmosIconAlignLeft = CosmosIconAlignLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAlignLeft, defineCustomElement };
